import React, {useEffect, useState} from "react";
import AttackTimeLineZigzag from "../timelines/AttackTimelines.stories";
import AttacksDataTable from "../tables/AttacksDataTable";
import {useDispatch, useSelector} from "react-redux";
import {fetchCustomers, fetchRequestedAttackDetails, fetchRequestedAttacks} from "../../../actions";
import {
    bbFormattedDateString,
    bbIsRequestedAttackDetailed,
} from "../../../util/bbHelpers";
import {Card, CardActions, Collapse} from "@material-ui/core";
import Base64ViewerDialog from "../modals/Base64ViewerDialog";
import BBIconExeExecuteCode from "../../../assets/bbCustomIcons/BBIconExeExecuteCode";
import RequestAttackButton from "../controllers/RequestAttackButton";
import Tooltip from "@material-ui/core/Tooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import AttackTimelineDialog from "../modals/AttackTimelineDialog";
import {Badge} from "reactstrap";
import IconButton from "@material-ui/core/IconButton";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {makeStyles} from "@material-ui/core/styles";
import Skeleton from "react-loading-skeleton";
import GhostTimeline from "../timelines/GhostTimeline"
import InsiderAttackTimelineStepper from "./InsiderAttackTimelineStepper";
import {HashLink as Link} from "react-router-hash-link";
import AttackInspectorBanner from "../../../assets/images/Attack-Inspector.svg";

const useStyles = makeStyles((theme) => ({
    // root: {
    //     width: '100%',
    //     textAlign: "center",
    //     padding: '2px 16px',
    // },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    expandIcon: {
        fontSize: 26,
    },
    footer: {

        // borderTop: "solid 2px gray",
        // borderBottom: "solid 9px gray",
        padding: 0,
    },
    collapse: {

    },
}));

const Inspector = (props) => {
    const {defaultAttackId,
        customerId,
        // allowSwitchingCustomerInView = false,
        onChangeAttack = (attackId) => null,
        showTimelineOnly = false,
    } = props;
    const [attackId, setAttackId] = useState(defaultAttackId ? defaultAttackId : null);

    const classes = useStyles();

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, loadingCustomers} = useSelector(({customer}) => customer);
    const {requestedAttacks, loadingRequestedAttacks, loadingRequestedAttackDetails} = useSelector(({insider}) => insider);
    const dispatch = useDispatch();
    //select the customer from the store if it exists, based on the props customerId
    const customer = customers ? customerId ? customers[customerId] : null : null;


    const requestedAttacksForCustomer = customer ? requestedAttacks ? requestedAttacks[customer.CustomerId] ? requestedAttacks[customer.CustomerId] : null : null : null;
    // const vectorAttacksForCustomer = customer
    //     ? customer.hasOwnProperty("vectors")
    //         ? mapObject(customer.vectors, (vectorId, vector) => )
    //         : null
    //     : null;

    const attackInView = requestedAttacksForCustomer
        ? requestedAttacksForCustomer[attackId]
            ? requestedAttacksForCustomer[attackId]
            : null
        : null;

    const [expanded, setExpanded] = React.useState(defaultAttackId ? false : true);
    const handleExpandClick = () => {
        setExpanded( !expanded);
    };

    useEffect(() => {

        if (!customers && !loadingCustomers) {
            // console.log("Customers is empty, fetching.")
            dispatch(fetchCustomers());
        } else if (customer && requestedAttacksForCustomer === null && !loadingRequestedAttacks) {
            // console.log("vectors is empty, fetching vectors for customerId = ", customer.CustomerId);
            dispatch(fetchRequestedAttacks({
                customerId: customer.CustomerId
            }));
        } else if (customer && attackInView && !loadingRequestedAttackDetails && !bbIsRequestedAttackDetailed(attackInView)) {
            dispatch(fetchRequestedAttackDetails({
                attackId: attackId,
                customerId: customer.CustomerId
            }))
        }

        if(customers && !attackInView) {
            setAttackId(defaultAttackId);
            if (!defaultAttackId || (requestedAttacksForCustomer && !attackInView)) {
                setExpanded(true);
            }
        } else if (customers && defaultAttackId) {
            setExpanded(false);
        }
        // alert(defaultAttackId);
        // alert(attackId);
        if(defaultAttackId !== attackId) {
            setAttackId(defaultAttackId);
        }

    }, [customers, loadingCustomers, requestedAttacks, loadingRequestedAttackDetails, loadingRequestedAttacks, dispatch, attackId, defaultAttackId, attackInView, customer, requestedAttacksForCustomer]);



    //see if that attack id exists
    //if not/fetch it
    //parse the events
    //put into the data format

    //test id for bluth in dev server db : 6477b797-6e38-44e5-819b-71cc1861d28a

    const onSelectRow = (params) => {
        // console.log(params);
        // alert("hell");
        // setAttackId("6477b797-6e38-44e5-819b-71cc1861d28a")
        setAttackId(params.data.id);
        setExpanded(false)

        onChangeAttack(params.data.id);

    }


    const timelineAndLoaderComponent = <>{(loadingCustomers || loadingRequestedAttacks || loadingRequestedAttackDetails)
        ? <GhostTimeline/>
        : attackInView && bbIsRequestedAttackDetailed(attackInView)
            ? <AttackTimeLineZigzag detailedAttackObject={attackInView}/>
            : <><em>Select a valid attack to view. You can order more attacks from the <Link to={"/board/CIRT/insider"}>Insider Threat module</Link>.</em></>
}</>

    return (
        <>
            {!showTimelineOnly
                ? <>
                    <div className="row">

                        <div className={"col-5 "}>
                            <div className={"mx-0 px-0 "}>
                                <div style={{backgroundImage: `url(${AttackInspectorBanner})`,  width: "400px", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>

                            </div>
                        </div>
                        <div className={"col-1 "}/>
                        <div className={"col-6"}>
                            {/*<CIRTContinuousControlWidget customerId={customerInView}/>*/}
                            <h3>The play-by-play Hacker's Perspective <Tooltip title={"The Attack Inspector tells the story of the entire attack cycle against your defenses.  See where you're strong, and see where you're at risk with features like the Attack Browser and Attack Timeline. The Attack Inspector allows you to analyze your Insider Attacks. Coming Soon: Inspect attacks from Perimeter."}><InfoSharpIcon style={{fontSize: "20px"}} className={``}/></Tooltip></h3>
                            <p>Dive deeper into each <Link to={"/board/CIRT/insider"}>Insider Attack</Link>.  See what our attacks have done, where your defenses were effective, and where you are at risk. </p>

                        </div>

                    </div>
                    <hr/>
                    <div className="row">

                        <div className="col-12">
                            {/*Attack selector data table*/}
                            {/*AttackId is {attackId}*/}
                            {/*customerId is {customerId}*/}
                            <Card className={"mb-3 px-2 text-center"} elevation={2}>
                                {/*<Tooltip title={"Expand for more information."}>*/}
                                <CardActions disableSpacing onClick={() => handleExpandClick()} type={"button"}>
                                    {/*<IconButton aria-label="add to favorites">*/}
                                    {/*    <FavoriteIcon />*/}
                                    {/*</IconButton>*/}
                                    {/*<IconButton aria-label="share">*/}
                                    {/*    <ShareIcon />*/}
                                    {/*</IconButton>*/}
                                    <Tooltip title={"Expand to view more Insider Attacks."}>
                                        <h1>Browse Insider Attacks</h1>
                                    </Tooltip>

                                    <Tooltip title={"Expand to view more Insider Attacks."}>
                                        <IconButton
                                            className={clsx(classes.expand, {
                                                [classes.expandOpen]: expanded,
                                            })}

                                            aria-expanded={expanded}
                                            aria-label="show more"
                                        >
                                            <ExpandMoreIcon className={classes.expandIcon} />
                                        </IconButton>
                                    </Tooltip>


                                </CardActions>
                                {/*</Tooltip>*/}
                                <Collapse in={expanded} timeout="auto" className={classes.collapse}>
                                    <AttacksDataTable
                                        customerId={customerId}
                                        onRowSelected={onSelectRow}
                                    />
                                    <h4><em>Order more Insider Attacks from the <Link to={"/board/CIRT/insider"}>Insider Threat module</Link>.</em></h4>
                                </Collapse>
                            </Card>


                        </div>
                    </div>
                    {(loadingCustomers || loadingRequestedAttacks || loadingRequestedAttackDetails)
                        ?
                        <><div className={"row"}>
                            <div className="col-3">
                                <h2><Skeleton/>
                                </h2>
                            </div>
                            <div className="col-3">

                                <h4> <Skeleton/>
                                </h4>

                            </div>
                            <div className="col-3">
                                <h4><Skeleton/></h4>
                            </div>
                            <div className="col-3">
                                <h4><Skeleton/></h4>
                            </div>
                        </div>
                            <div className={"row"}>
                                <div className="col-12">
                                    <div className={"px-5 mx-5 my-3"} style={{fontSize: "large"}}>
                                        <Skeleton/>
                                    </div>
                                </div>
                            </div>
                            <div className={"row"}>
                                <div className="col-12">
                                    <InsiderAttackTimelineStepper attackObject={{}} isLoading/>
                                </div>
                            </div>

                        </>
                        : attackInView && bbIsRequestedAttackDetailed(attackInView)
                            ? <><div className={"row"}>
                                <div className="col-3">
                                    <h2>{attackInView.Toolkit.Name} Attack
                                        <Tooltip title={attackInView.Toolkit["Description Long"]}>
                                            <InfoSharpIcon style={{fontSize: "smaller"}} className={`mx-2`}/>
                                        </Tooltip>
                                    </h2>
                                    <h5>{attackInView["Attack Type"].Name}&nbsp;
                                        <Tooltip
                                            title={attackInView["Attack Type"].Description}>
                                            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
                                        </Tooltip></h5>
                                </div>

                                <div className="col-3">
                                    {attackInView["Attack Package Details"]["Attack Package Difficulty"] &&
                                        <>
                                            <h5>Difficulty</h5>
                                            <h4>{attackInView["Attack Package Details"]["Attack Package Difficulty"].Name}&nbsp;
                                                <Tooltip
                                                    title={attackInView["Attack Package Details"]["Attack Package Difficulty"].Description}>
                                                    <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
                                                </Tooltip>
                                            </h4>

                                        </>

                                    }
                                </div>

                                <div className="col-3">
                                    <h5>Date Requested</h5>
                                    <h4><Tooltip title={bbFormattedDateString(attackInView["Requested DateTime"], "utc")}><span>{bbFormattedDateString(attackInView["Requested DateTime"], "medium")}</span></Tooltip></h4>
                                </div>
                                <div className="col-3">
                                    {attackInView["Attack Package Details"]["Attack Package Objective"] &&
                                    <>
                                        <h5>Attack Objective</h5>
                                        <h4>{attackInView["Attack Package Details"]["Attack Package Objective"].Name}&nbsp;
                                            <Tooltip
                                                title={attackInView["Attack Package Details"]["Attack Package Objective"].Description}>
                                                <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
                                            </Tooltip>
                                        </h4>

                                    </>
                                    }
                                </div>
                            </div>
                                <div className={"row"}>
                                    <div className="col-12">
                                        <div className={"px-5 mx-5 my-3"} style={{fontSize: "large"}}>
                                            <Tooltip title={`${attackInView["Status"]["Description"]}`}>
                                        <span>
                                            <Badge className={"d-block"} color={attackInView["Status"]["Id"] === 5 ? "bb-risk-lowest" : attackInView["Status"]["Id"] === 8 ? "bb-risk-high" : attackInView["Status"]["Id"] === 4 ? "bb-risk-highest" : "lightest-gray"}>{attackInView["Status"]["Name"]}</Badge>
                                        </span>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                            <div className={"row"}>
                                <div className="col-12">
                                    {attackInView.Phases
                                        ? attackInView["Attack Type"].Id === 1
                                            ?<InsiderAttackTimelineStepper attackObject={attackInView} showOnlyLast={5} />
                                            : null
                                        : <InsiderAttackTimelineStepper attackObject={{}} isLoading/>
                                    }
                                </div>
                            </div>

                            </>
                            : null

                    }


                <div className="row">

                    <div className="col-9">
                        <div className={"jr-card"}>
                            <h1>Attack Timeline</h1>
                            {timelineAndLoaderComponent}
                        </div>

                    </div>
                    {(loadingCustomers || loadingRequestedAttacks || loadingRequestedAttackDetails)
                        ? <div className="col-3">
                            <div className={"jr-card"}>
                                <div className="row">
                                    <div className="col-12">
                                        <h2>Options</h2>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-4">
                                        <div style={{margin:2}}>

                                            <Skeleton />
                                        </div>
                                        <h5 className={"text-center bb-font-fridge"}>
                                            <Skeleton/>
                                        </h5>
                                    </div>
                                    <div className="col-4">
                                        <div style={{margin: 2}}>
                                            <Skeleton />
                                        </div>
                                        <h5 className={"text-center bb-font-fridge"}>
                                            <Skeleton/>
                                        </h5>
                                    </div>
                                    <div className="col-4">
                                        <div style={{margin: 2}}>
                                            <Skeleton />
                                        </div>
                                        <h5 className={"text-center bb-font-fridge"}>
                                            <Skeleton/>
                                        </h5>

                                    </div>
                                </div>
                            </div>

                            <div className="contact-block jr-card mb-0">
                                <h2>About this Attack</h2>
                                <h6><Skeleton /></h6>
                                <div className={"px-2 mx-2 my-2"} style={{fontSize: "medium"}}>
                                    <Skeleton />
                                </div>
                                <h4><Skeleton /></h4>
                                <h6><Skeleton /></h6>
                                <ul className="contact-info vertical">
                                    <li>
                                        <i className="zmdi zmdi-pin zmdi-hc-fw"/>
                                        <div className="contact-body">
                                            <h4 className="text-uppercase">BASICS</h4>

                                            <p>Date Requested: <Skeleton /></p>

                                            <p>Attack Objective: <Skeleton /></p>

                                        </div>
                                    </li>

                                    <li>
                                        <i className="zmdi zmdi-card-travel zmdi-hc-fw"/>
                                        <div className="contact-body">
                                            <h4 className="text-uppercase">Attack Package</h4>
                                            <h4><Skeleton /></h4>
                                            <p><Skeleton /></p>

                                        </div>
                                    </li>
                                </ul>
                            </div>

                        </div>
                        : attackInView && bbIsRequestedAttackDetailed(attackInView)
                            ? <div className="col-3">
                                <div className={"jr-card"}>
                                    <div className="row">
                                        <div className="col-12">
                                            <h2>Options</h2>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-4 align-self-center">
                                            <div style={{margin: "2px", textAlign: "center"}}>

                                                <AttackTimelineDialog
                                                    attackId={attackId}
                                                    customerId={customerId}
                                                    hideViewFullTimelineButton
                                                    // isTimelineButtonDisabled={isTimelineButtonDisabled}
                                                    // onClickToAttackTimeline={() => onClickToAttackTimeline(params.row.id)}
                                                />

                                            </div>
                                            <h5 className={"text-center bb-font-fridge"}>
                                                Wide View
                                            </h5>
                                        </div>
                                        <div className="col-4 align-self-center">
                                            <div style={{margin: "2px", textAlign: "center"}}>
                                                <Base64ViewerDialog
                                                    attackId={attackId}
                                                    customerId={customerId}
                                                    displayIcon={<BBIconExeExecuteCode className={"text-electric-blue"}/>}
                                                    // displayState = {1} //3 is stop
                                                />

                                            </div>
                                            <h5 className={"text-center bb-font-fridge"}>
                                                View Script
                                            </h5>
                                        </div>
                                        <div className="col-4 align-self-center">
                                            <div style={{margin: "2px", textAlign: "center"}}>
                                                <RequestAttackButton
                                                    customerId={customerId}
                                                    attackPackageId={attackInView.AttackPackageId}
                                                    iconVariant = {2}
                                                    // base64={"test"}
                                                    // justAdded = {params.row.wasRowJustAdded}
                                                />

                                            </div>
                                            <h5 className={"text-center bb-font-fridge"}>
                                                Reattack
                                            </h5>

                                        </div>
                                    </div>
                                </div>

                                <div className="contact-block jr-card mb-0">
                                    <h2>About this Attack</h2>
                                    <h6>{attackInView["Attack Type"].Name}</h6>
                                    <div className={"px-2 mx-2 my-2"} style={{fontSize: "medium"}}>
                                        <Tooltip title={`${attackInView["Status"]["Description"]}`}>
                                                <span>
                                                    <Badge className={"d-block"} color={attackInView["Status"]["Id"] === 5 ? "bb-risk-lowest" : attackInView["Status"]["Id"] === 8 ? "bb-risk-high" : attackInView["Status"]["Id"] === 4 ? "bb-risk-highest" : "lightest-gray"}>{attackInView["Status"]["Name"]}</Badge>
                                                </span>
                                        </Tooltip>
                                    </div>
                                    <h4>{attackInView.Toolkit.Name}&nbsp;
                                        <Tooltip title={attackInView.Toolkit["Description Long"]}>
                                            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
                                        </Tooltip></h4>
                                    <h6>{attackInView.Toolkit["Description Short"]}</h6>
                                    <ul className="contact-info vertical">
                                        <li>
                                            <i className="zmdi zmdi-pin zmdi-hc-fw"/>
                                            <div className="contact-body">
                                                <h4 className="text-uppercase">BASICS</h4>

                                                <p>Date Requested: <Tooltip title={bbFormattedDateString(attackInView["Requested DateTime"], "utc")}><span>{bbFormattedDateString(attackInView["Requested DateTime"], "short")}</span></Tooltip></p>
                                                {attackInView["Attack Package Details"]["Attack Package Objective"] &&
                                                <p>Attack Objective: {attackInView["Attack Package Details"]["Attack Package Objective"].Name} &nbsp;
                                                    <Tooltip title={attackInView["Attack Package Details"]["Attack Package Objective"].Description}>
                                                        <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
                                                    </Tooltip></p>
                                                }



                                            </div>
                                        </li>

                                        <li>
                                            <i className="zmdi zmdi-card-travel zmdi-hc-fw"/>
                                            <div className="contact-body">
                                                <h4 className="text-uppercase">Attack Package</h4>
                                                <h4>{attackInView["Attack Package Details"].Name}</h4>
                                                <p>{attackInView["Attack Package Details"].Description}</p>
                                                <br/>
                                                {attackInView["Attack Package Details"]["Attack Package Difficulty"] &&
                                                <p>Difficulty: {attackInView["Attack Package Details"]["Attack Package Difficulty"].Name}&nbsp;
                                                    <Tooltip
                                                        title={attackInView["Attack Package Details"]["Attack Package Difficulty"].Description}>
                                                        <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
                                                    </Tooltip></p>
                                                }
                                            </div>
                                        </li>
                                        {attackInView.Phases && attackInView["Attack Type"].Id === 1 &&
                                            <li>
                                                <InsiderAttackTimelineStepper attackObject={attackInView} isVertical/>
                                            </li>

                                        }
                                    </ul>
                                    <div className={" text-center mx-0 mt-3 mb-0 py-0 px-0"}>
                                        <small >Attack ID: <br/>{attackId}</small>
                                    </div>
                                </div>

                            </div>

                            : <>
                            <div className="col-3">
                                <div className={"jr-card"}>
                                    <div className="row">
                                        <div className="col-12">
                                            <h2>Options</h2>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <p><em>Select an attack to view options. You can order more attacks from the <Link to={"/board/CIRT/insider"}>Insider Threat module</Link>.</em> </p>
                                    </div>
                                </div>

                                <div className="contact-block jr-card mb-0">
                                    <h2>About this Attack</h2>
                                    <p><em>Select an attack to view information.</em></p>
                                </div>
                            </div>
                            </>
                    }


                    <div className={"col-2"}>

                    </div>
                </div>
                    </>
                : <><div className={"row"}>
                    <div className="col-12">
                        <div className={"px-5 mx-5 my-3"} style={{fontSize: "large"}}>
                            <Tooltip title={`${attackInView["Status"]["Description"]}`}>
                                        <span>
                                            <Badge className={"d-block"} color={attackInView["Status"]["Id"] === 5 ? "bb-risk-lowest" : attackInView["Status"]["Id"] === 8 ? "bb-risk-high" : attackInView["Status"]["Id"] === 4 ? "bb-risk-highest" : "lightest-gray"}>{attackInView["Status"]["Name"]}</Badge>
                                        </span>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                    {attackInView.Phases
                    ? attackInView["Attack Type"].Id === 1
                            ?<InsiderAttackTimelineStepper attackObject={attackInView} showOnlyLast={5} />
                            : null
                    : <InsiderAttackTimelineStepper attackObject={{}} isLoading/>
                }

                {timelineAndLoaderComponent}</>
            }

        </>
    );
};

export default Inspector;